import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';

@Injectable({
    providedIn: 'root',
})
export class CampaignPerformanceService {
    private _baseUrl: string = '';
    private _token: string = '';

    public constructor(
        public appService: AppService,
        public http: HttpClient,
        @Inject('API_BASE_URL') baseurl: string,
    ) {
        this._baseUrl = baseurl;

        const loggedUserSession = localStorage.getItem('userSession');
        if (loggedUserSession) {
            const loggedUserToken =
                JSON.parse(loggedUserSession).AuthenticatedUser.Token;
            this._token = loggedUserToken;
        }
    }

    public getOverviews = (date: string): Observable<any> => {
        const apipath: string = 'campaignperformance/split/overviews';
        const fullPath: string = this._baseUrl + apipath + '?date=' + date;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public getCampaignPerformanceByCreditorId = (
        id: number,
        date: string,
    ): Observable<any> => {
        const apipath: string = 'campaignperformance/split/creditor/' + id;
        const fullPath: string = this._baseUrl + apipath + '?date=' + date;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public getCampaignPerformanceTotalByCreditorId = (
        id: number,
        date: string,
    ): Observable<any> => {
        const apipath: string =
            'campaignperformance/split/total/creditor/' + id;
        const fullPath: string = this._baseUrl + apipath + '?date=' + date;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };
}
